import { Subject } from 'rxjs';
import { ReplyItem } from '../reply';
import { get, keys, padEnd, padStart } from 'lodash';

export class RepliesOrder {
  private _groupBy: string = '';
  private _orderBy: 'timestamp' | 'displayName' | 'phoneNumber' | 'email' = 'displayName';
  private _orderDirection: 'asc' | 'desc' = 'asc';
  /**
   * every action to change filter will stream change event.
   */
  private changeEvent = new Subject<any>();
  get onChange() {
    return this.changeEvent.asObservable();
  }
  get groupBy() {
    return this._groupBy;
  }
  set groupBy(v) {
    if (v !== this._groupBy) {
      this._groupBy = v;
      this.changeEvent.next(null);
    }
  }
  get orderBy() {
    return this._orderBy;
  }
  set orderBy(v) {
    if (v !== this._orderBy) {
      this._orderBy = v;
      this.changeEvent.next(null);
    }
  }
  get orderDirection() {
    return this._orderDirection;
  }
  set orderDirection(v) {
    if (v !== this._orderDirection) {
      this._orderDirection = v;
      this.changeEvent.next(null);
    }
  }
  empty () {
    this._orderBy = 'displayName';
    this.changeEvent.next();
  }
  getGroupKeyValue(reply: ReplyItem): string {
    let val = reply.as;
    if (this.groupBy) {
      const query = get(reply, this.groupBy);
      if (query && typeof query === 'object') {
        val += '-' + keys(query).join('.');
      } else {
        val += '-' + query;
      }
    }
    return val;
  }
  getOrderKeyValue (reply: ReplyItem) {
    let str = this._getOrderKeyValue(reply);
    if (this.orderBy !== 'timestamp') {
      str = padEnd(str, 32, '0') + '-' + padEnd((reply.timestamp || '').toString(), 13, '9');
    } 
    return str;
  }
  private _getOrderKeyValue(reply: ReplyItem): string {
    let val = get(reply, [this.orderBy]);
    if (typeof val === 'string' && val.match(/\d+/g)) {
      return val.replace(/\d+/g, a => {
        return padStart(a, 3, '0');
      });
    } else if (typeof val === 'number') {
      return val.toString();
    } else {
      return '';
    }
  }

}
